<template>
  <transition name="fade">
    <div class="container-fluid" id="register">
      <script type="application/ld+json">
        {
          "@context": "http://schema.org",
          "@graph": [
            {
              "@type": "Article",
              "url": "https://www.teddi.co/travaux/",
              "headline": "Travaux ← Teddi",
              "description": "Avec Teddi, trouvez les meilleurs entrepreneurs pour vos travaux de rénovation.",
              "datePublished": "2020-06-14T17:47:50.000Z",
              "dateModified": "2020-06-15T09:20:51.000Z",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://www.teddi.co/travaux/"
              },
              "publisher": {
                "@type": "Organization",
                "@id": "https://www.teddi.co/",
                "name": "Teddi",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://www.teddi.co/assets/socials/fb-profile.png",
                  "width": 1000,
                  "height": 1000
                }
              },
              "author": {
                "@type": "Person",
                "name": "Thomas"
              }
            }
          ]
        }
      </script>
      <b-row class="pt-md-4 vh-100">
        <b-col md="5" offset-md="2" class="px-md-4">
          <div class="d-flex align-items-center py-3">
            <b-img
              v-if="isFormPropertyView"
              class="icon-md mr-2"
              alt="ruler"
              :src="require('@/assets/icons/ruler.png')"
            >
            </b-img>
            <!-- BACK -->
            <b-img
              v-if="isFormUserView"
              @click="
                isFormUserView = false;
                isFormPropertyView = true;
              "
              class="icon-md mr-2 cursor-pointer"
              alt="back-hands"
              :src="require('@/assets/icons/back-hands.svg')"
            >
            </b-img>
            <!-- BACK -->
            <h1>Vos travaux</h1>
          </div>

          <b-form class="text-left" @submit.prevent>
            <!-- FIRST STEP VIEW -->
            <div v-show="isFormPropertyView">
              <transition name="fade">
                <RefurbishmentType />
              </transition>
              <transition name="fade">
                <div
                  class="d-flex align-items-center"
                  v-if="isRefurbishmentTypeSet"
                >
                  <h5 class="mb-0">pour un montant de travaux estimé à</h5>
                  <BudgetMax />
                </div>
              </transition>
              <transition name="fade">
                <SearchStage
                  v-if="isRefurbishmentTypeSet && isSearchStageSet"
                />
              </transition>

              <transition name="fade">
                <div
                  class="d-flex align-items-center"
                  v-if="
                    isRefurbishmentTypeSet && isSearchStageSet && isBudgetMaxSet
                  "
                >
                  <h5 class="mb-0">la surface est</h5>
                  <SurfaceMin />
                </div>
              </transition>
              <transition name="fade">
                <div
                  class="d-flex align-items-center"
                  v-if="
                    isRefurbishmentTypeSet &&
                    isSearchStageSet &&
                    isBudgetMaxSet &&
                    isSurfaceMinSet
                  "
                >
                  <h5 class="mb-0 mr-3">situé</h5>
                  <PropertyAddress class="w-100" />
                </div>
              </transition>
            </div>
            <!-- SECOND STEP VIEW -->
            <transition name="fade">
              <div v-if="isFormUserView">
                <div
                  class="mt-3"
                  v-if="
                    isRefurbishmentTypeSet &&
                    isSearchStageSet &&
                    isBudgetMaxSet &&
                    isSurfaceMinSet &&
                    isPropertyAddressSet
                  "
                >
                  <h5 class="mb-0">Mon prénom</h5>
                  <FirstName />
                </div>
                <transition name="fade">
                  <div
                    class="mt-3"
                    v-if="
                      isRefurbishmentTypeSet &&
                      isPropertyAddressSet &&
                      isSearchStageSet &&
                      isBudgetMaxSet &&
                      isSurfaceMinSet &&
                      isFirstNameSet
                    "
                  >
                    <h5 class="mb-0">Mon nom</h5>
                    <LastName />
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    class="mt-3"
                    v-if="
                      isRefurbishmentTypeSet &&
                      isPropertyAddressSet &&
                      isSearchStageSet &&
                      isBudgetMaxSet &&
                      isSurfaceMinSet &&
                      isFirstNameSet &&
                      isLastNameSet
                    "
                  >
                    <h5 class="mb-2">Mon adresse email est</h5>
                    <Email />
                  </div>
                </transition>

                <transition name="fade">
                  <div
                    class="mt-3"
                    v-if="
                      isRefurbishmentTypeSet &&
                      isPropertyAddressSet &&
                      isSearchStageSet &&
                      isBudgetMaxSet &&
                      isSurfaceMinSet &&
                      isFirstNameSet &&
                      isLastNameSet &&
                      isEmailSet
                    "
                  >
                    <h5 class="mb-0">J'aimerais qu'on me rappelle au</h5>
                    <Phone />
                  </div>
                </transition>
              </div>
            </transition>
          </b-form>
        </b-col>
        <b-col md="3" class="d-none d-md-block">
          <div class="d-flex align-items-center justify-content-center py-3">
            <b-img
              class="icon-md mr-2"
              alt="worker"
              :src="require('@/assets/icons/construction-worker.png')"
            >
            </b-img>
          </div>
          <FormHelper class="pb-5" />
        </b-col>
      </b-row>
      <!-- NEXT -->
      <div
        @click="
          isFormUserView = true;
          isFormPropertyView = false;
        "
        class="cursor-pointer d-flex justify-content-center fixed-bottom py-2 py-md-1 bg-blue"
        v-if="
          isRefurbishmentTypeSet &&
          isSearchStageSet &&
          isBudgetMaxSet &&
          isSurfaceMinSet &&
          isPropertyAddressSet &&
          isFormPropertyView
        "
      >
        <IconNext class="icon white slide-right" />
      </div>
      <!-- SUBMIT -->
      <vue-recaptcha
        :loadRecaptchaScript="true"
        ref="invisibleRecaptcha"
        size="invisible"
        sitekey="6LfTAv0UAAAAAIqxP0ib1Y-RAbI4FLpah7Vf39VS"
        @verify="onCaptchaVerified"
        @expired="onCaptchaExpired"
      >
        <div
          @click="recaptcha()"
          class="fixed-bottom py-2 py-md-1 bg-blue submit"
          v-if="
            isRefurbishmentTypeSet &&
            isPropertyAddressSet &&
            isSearchStageSet &&
            isBudgetMaxSet &&
            isSurfaceMinSet &&
            isFirstNameSet &&
            isLastNameSet &&
            isEmailSet &&
            isFormUserView &&
            isPhoneSet &&
            isPhoneValid
          "
        >
          <IconSubmit class="icon white" />
        </div>
      </vue-recaptcha>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Vue from "vue";
import VueRecaptcha from "vue-recaptcha";
import SearchStage from "@/components/content/SearchStage.vue";
import PropertyAddress from "@/components/content/PropertyAddress.vue";
import BudgetMax from "@/components/content/BudgetMax.vue";
import SurfaceMin from "@/components/content/SurfaceMin.vue";
import RefurbishmentType from "@/components/content/RefurbishmentType.vue";
import FirstName from "@/components/content/FirstName.vue";
import LastName from "@/components/content/LastName.vue";
import Email from "@/components/content/Email.vue";
import Phone from "@/components/content/Phone.vue";
import IconSubmit from "@/components/icons/IconSubmit.vue";
import IconNext from "@/components/icons/IconNext.vue";
import IconBack from "@/components/icons/IconBack.vue";
import FormHelper from "@/components/content/FormHelper.vue";

export default {
  components: {
    PropertyAddress,
    SearchStage,
    BudgetMax,
    SurfaceMin,
    RefurbishmentType,
    Email,
    Phone,
    IconSubmit,
    FormHelper,
    VueRecaptcha,
    FirstName,
    LastName,
    IconNext,
    IconBack,
  },
  metaInfo: {
    title: "Comparez les entrepreneurs pour vos travaux de rénovation",
    titleTemplate: "%s ← Teddi",
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Trouvez les meilleurs entrepreneurs pour effectuer vos travaux de rénovation. Découvrez notre service qui vous permettra de les comparer et ainsi faire le meilleur choix pour vos travaux.",
      },
      {
        property: "og:title",
        content:
          "Comparez les entrepreneurs pour vos travaux de rénovation ← Teddi",
      },
      { property: "og:site_name", content: "Teddi" },
      { property: "og:type", content: "website" },
      {
        property: "og:url",
        content: "https://www.teddi.co/travaux",
      },
      {
        property: "og:image",
        content: "https://www.teddi.co/assets/socials/fb-cover.jpg",
      },
      {
        property: "og:description",
        content:
          "Trouvez les meilleurs entrepreneurs pour effectuer vos travaux de rénovation. Découvrez notre service qui vous permettra de les comparer et ainsi faire le meilleur choix pour vos travaux.",
      },
    ],
    link: [{ rel: "canonical", href: "https://www.teddi.co/travaux" }],
  },
  data() {
    return {
      isRecaptchaValid: false,
      isFormPropertyView: true,
      isFormUserView: false,
    };
  },
  computed: {
    ...mapState(["isPhoneValid", "hasInputBeenChanged"]),
    ...mapGetters([
      "isRefurbishmentTypeSet",
      "isPropertyAddressSet",
      "isLocationSet",
      "isBudgetMaxSet",
      "isSurfaceMinSet",
      "isSearchStageSet",
      "isEmailSet",
      "isFirstNameSet",
      "isLastNameSet",
      "isPhoneSet",
    ]),
  },

  methods: {
    ...mapMutations({ setHasInputBeenChanged: "SET_HAS_INPUT_BEEN_CHANGED" }),
    recaptcha() {
      this.$refs.invisibleRecaptcha.execute();
    },
    onCaptchaExpired() {
      this.$refs.invisibleRecaptcha.reset();
    },
    async onCaptchaVerified(token) {
      console.log("logging in...", token);
      this.$refs.invisibleRecaptcha.reset();
      await this.sendToPartnerRefurbishment();
    },
    ...mapActions(["sendToPartnerRefurbishment"]),
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
h1 {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0;
}
form {
  div.d-flex {
    margin-bottom: 1rem;
  }
  padding-bottom: 8rem;
}
</style>
